// Responsive product images: the server serves resized WebP versions via ?w=<width>.
// Shared by client (srcset) and server (preload tags must match the srcset exactly).

/** Thumbnail width; the server crops it square (thumbnails are shown in square boxes). */
export const THUMB_WIDTH = 96;

/** Widths offered to the browser for product card images; the server crops them to 4:3 like the card frame. */
export const CARD_IMAGE_WIDTHS = [400, 720, 1080] as const;

/** Widths the server is allowed to produce (keeps the cache small and prevents abuse). */
export const IMAGE_WIDTHS = [THUMB_WIDTH, ...CARD_IMAGE_WIDTHS] as const;

/** Height/width ratio the server crops to for a given width (centre crop, same as CSS object-cover). */
export const cropRatio = (width: number) => (width === THUMB_WIDTH ? 1 : 3 / 4);

/** Displayed width of a card image: 3 columns from 1024px, 2 columns from 640px, else full width. */
export const CARD_IMAGE_SIZES = "(min-width: 1024px) 340px, (min-width: 640px) 45vw, 92vw";

const isResizable = (src: string) => src.startsWith("/public-objects/");

/** Some stored file names contain spaces and commas; encode them so the URL is valid inside srcset. */
const encodePath = (src: string) => (/%[0-9a-f]{2}/i.test(src) ? src : encodeURI(src)).replace(/,/g, "%2C");

export function imageUrl(src: string, width: number): string {
  return isResizable(src) ? `${encodePath(src)}?w=${width}` : src;
}

export function cardImageSrcSet(src: string): string | undefined {
  if (!isResizable(src)) return undefined;
  return CARD_IMAGE_WIDTHS.map((w) => `${imageUrl(src, w)} ${w}w`).join(", ");
}
